/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type RecurrenceInterval = typeof RecurrenceInterval[keyof typeof RecurrenceInterval];


export const RecurrenceInterval = {
  WEEKLY: 'WEEKLY',
} as const;
